import { ReferralRequest } from "@/types";

import { axios } from "../axios.instance";

export type RejectReferralRequest = {
  referralRequestId: ReferralRequest["id"];
};

export type RejectReferralResponse = null;

export const rejectReferral = async (params: RejectReferralRequest): Promise<RejectReferralResponse> => {
  const { data } = await axios.post(`/referral-requests/my/${params.referralRequestId}/reject`);

  return data;
};
